@if (!erreurRecuperation()) {
  <div class="mes-projects">
    <app-liste-generique [proprietesAffichees]="proprietesAfficheesProjets()" [listeObjets]="tabProjets()"
      [filtreParDefaut]="{'prop':'estTermine','val':'false','type':'boolean'}" (clicObjetEvent)="ouvrirProjet($event)"
    [triParDefaut]="{'prop':'nom', 'type':'string'}" [listeModifiee]="listeModifiee"></app-liste-generique>
    <div class="footer">
      <button *showIfHasRole="'create_project'" class="btn btn-primary" (click)="ouvrirModaleAjout()"
        style="margin-right:10px;">
        <i class="fas fa-plus" style="padding-right: 5px;"></i>{{'GLOBAL.AJOUTER' | translate}}
      </button>
      <button type="button" class="btn btn-primary" (click)="lancerExport()" style="margin-right:10px;">
        <i class="fas fa-file-export" style="padding-right:5px"></i>{{'MON_SITE.EXPORTER_DONNEE_ANALYSE' | translate}}
      </button>
      <button type="button" class="btn btn-primary" (click)="openModalReports()">
        <i class="fas fa-file-excel" style="padding-right:5px"></i>{{'MON_SITE.REPORTS' | translate}}
      </button>
    </div>
    <div class="modal fade" bsModal #modalNoWorkflow="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1"
      aria-labelledby="dialog-static-name">
      <div class="modal-dialog modal-sm">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title pull-left">{{'GLOBAL.PROJET' | translate}}</h4>
            <button type="button" class="close pull-right" aria-label="Close" (click)="modalNoWorkflow.hide()"
              title="{{'GLOBAL.FERMER' | translate}}">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p class="not-selectable">{{'MES_PROJETS.MESSAGE_NO_WORKFLOW' | translate}}</p>
            <div class="btn-toolbar justify-content-end">
              <button type="button" class="btn btn-secondary"
              (click)="modalNoWorkflow.hide()">{{'GLOBAL.FERMER' | translate}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div bsModal #modalExport="bs-modal" class="modal fade" tabindex="-1"
      aria-labelledby="dialog-child-name" [config]="{backdrop: 'static', keyboard:false}">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title pull-left not-selectable">{{'GLOBAL.EXPORT_DONNEES' | translate}}</h4>
          </div>
          <div class="modal-body">
            <div class="not-selectable" [ngClass]="aucuneDonnee() ? '' :'text-center'">
              {{aucuneDonnee() ? ('GLOBAL.AUCUNE_DONNEE_EXPORT' | translate) : ('GLOBAL.PREPARATION_EXPORT' | translate)}}
            </div>
            @if (aucuneDonnee()) {
              <div class="btn-toolbar justify-content-end">
                <button type="button" class="btn btn-secondary"
                (click)="modalExport.hide()">{{'GLOBAL.FERMER' | translate}}</button>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
}
@if (erreurRecuperation()) {
  <div class="custom-alert custom-alert-sm">
    {{'GLOBAL.ERREUR_RECUP_DONNEES' | translate }}
  </div>
}

